import React from 'react'
import axios from 'axios'

class VideoLibrary extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.video_library || []
		}
	}

	handleAddNewItem(){
		// Render a new form.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			videoId: '',
			imageURL: '',
			title: ''
		})

		// Save it to state.
		this.setState({ items })
	}

	handleGetVideoData(form){
		// lEEmORyxpho
		form.querySelector('.videoId').value && axios.get('https://www.googleapis.com/youtube/v3/videos', {
			params: {
				key: 'AIzaSyAiSUAYLoTmZQ364rFHnbEmsYn5cb0pmxg',
				part: 'snippet',
				id: form.querySelector('.videoId').value
			}
		}).then( response => {
			// Update the properties in the state.
			const items = this.state.items

			items.map( item => {
				// eslint-disable-next-line
				if(item.id == form.getAttribute('data-id')){
					item.videoId = encodeURIComponent(form.querySelector('.videoId').value)
					item.title = encodeURIComponent(response.data.items[0].snippet.title)
					item.imageURL = encodeURIComponent(response.data.items[0].snippet.thumbnails.medium.url)
				}
				return item
			})

			this.setState({ items })

			// Notify the parent.
			this.props.handleVideoUpdate && this.props.handleVideoUpdate()
		})
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({
			items: items,
		}, () => {
			// Notify the parent.
			this.props.handleVideoUpdate && this.props.handleVideoUpdate()
		})
	}

	render() {
		return (
			<section className="media_library">
				<h3>Video Library</h3>
				<div className="grid">
					{this.state.items.map( (item) => {
						return (
							<div key={item.id} data-id={item.id} className="video_container">
								<input type="text" defaultValue={decodeURIComponent(item.videoId)} placeholder="Video ID" className="videoId" />
								{ item.imageURL && <img src={decodeURIComponent(item.imageURL)} data-src={decodeURIComponent(item.imageURL)} alt={item.id} /> }
								<label className="video_title">{decodeURIComponent(item.title)}</label>
								{ !item.videoId && <button className="getVideoData button" onClick={ (e) => {this.handleGetVideoData(e.target.closest('div'))} }>Get Video Data</button>}
								{ item.videoId && <button className="delete" onClick={ (e) => {this.handleItemRemove(item.id)} }>Delete</button> }
							</div>
						)
					})}
				</div>
				<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add Video</button>
			</section>
		)
	}
}

export default VideoLibrary



/*
import React, { Component } from 'react'

// YGv7QdblmSU
// NaTCuXjbWXI
// C0EgzJ0KGxg
// NpOtkhBcc8k
// imtPF2b2Q4M

export default class App extends Component {
    state = {
        videoIds: [],
    }
    handleAdd (e) {
        const videoIds = this.state.videoIds
        videoIds.push(e.target.value)
        this.setState({
            videoIds,
        })
    }
    handleRemove (videoId) {
        const videoIds = this.state.videoIds
        videoIds.splice(videoIds.indexOf(videoId), 1)
        this.setState({
            videoIds,
        })
    }
    render() {
        return (
            <React.Fragment>
                {this.state.videoIds.map( videoId => <div key={videoId}>
                    <iframe
                        title="yt"
                        width="200"
                        height="112.5"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameborder="0"
                        allow="accelerometer autoplay encrypted-media gyroscope picture-in-picture"
                    allowfullscreen></iframe>
                    <div>
                        <span>Video ID:{videoId}</span>
                        <button onClick={ () => this.handleRemove(videoId)}>Remove video</button>
                    </div>
                </div>)}
                <input
                    type="text"
                    value=""
                    placeholder="Enter YouTube Video ID..."
                    onChange={ e => this.handleAdd(e)} />
            </React.Fragment>
        )
    }
}
*/



// WEBPACK FOOTER //
// ./src/components/video_library.js